import React from 'react'
import logo from '../img/bash.png'


export const Header = () => {

    return (
    <div className="container">
        <nav className="nav-extended z-depth-1">
          <div className="nav-wrapper">
              <div className="brand-logo"><a href="/"><img src={logo} alt="Logo" /></a>
                  <div className="typewriter"><a href="/"><p>NoSkiddie</p></a></div>
              </div>
      {/* <a href="#" data-target="mobile" className="sidenav-trigger"><i className="material-icons">menu</i></a> */}
      <ul id="nav-mobile" className="right hide-on-med-and-down">
        <li><a href="/">Main</a></li>
        <li><a href="/skill">My skills</a></li>
        <li><a href="/portfolio">My portfolio</a></li>        
        <li><a href="/auth">Login</a></li>
      </ul>
         </div>
        </nav>

        <ul className="sidenav" id="mobile">
            <li><a href="/">Main</a></li>
            <li><a href="/auth">Login</a></li>
        </ul>
        </div>
)
}

export default Header